import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';
import EventIcon from '@mui/icons-material/Event';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PeopleIcon from '@mui/icons-material/People';
import { VerifiedUser } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import PortalShell from './layout/PortalShell';

const ADMIN_NAV = [
  { label: 'Dashboard', path: '/dashboard', icon: DashboardIcon },
  // { label: 'Requests', path: '/requests', icon: PeopleIcon },
  { label: 'Posts', path: '/posts', icon: PostAddIcon },
  { label: 'Users', path: '/users', icon: PeopleIcon },
  { label: 'Vetted Users', path: '/vetted-users', icon: VerifiedUser },
  { label: 'Events', path: '/events', icon: EventIcon },
  { label: 'Aria Handsoff', path: '/aria-handsoff', icon: SupportAgentIcon },
  { label: 'Admin Management', path: '/admin-management', icon: AdminPanelSettingsIcon },
  { label: 'Partner Management', path: '/partner-management', icon: HandshakeIcon },
];

const Layout = ({ children, onSignOut }) => {
  const { adminProfile } = useAuth();

  const user = {
    name: adminProfile?.fullName || 'Admin',
    email: adminProfile?.email || '',
    avatarUrl: adminProfile?.avatarUrl || undefined,
  };

  return (
    <PortalShell
      navItems={ADMIN_NAV}
      user={user}
      notificationsPath="/notifications"
      onSignOut={onSignOut}
      signOutRedirectPath="/login"
    >
      {children}
    </PortalShell>
  );
};

export default Layout;
